// Список авто-инсайтов от бэкенда. Окрашивается по tone.

import type { Insight, InsightTone } from '../../api/types';
import { AlertTriangleIcon, CheckCircleIcon, InfoIcon } from '../icons';

// Иконку берём из tone, а не из insight.emoji: эмодзи из API в интерфейсе
// не показываем (он остаётся для сообщений бота).
function toneIcon(tone: InsightTone): JSX.Element {
  if (tone === 'positive') return <CheckCircleIcon size={18} />;
  if (tone === 'warning') return <AlertTriangleIcon size={18} />;
  return <InfoIcon size={18} />;
}

type Props = {
  insights: Insight[];
  onAction?: (deepLink: string) => void;
};

export function InsightsList({ insights, onAction }: Props): JSX.Element {
  if (insights.length === 0) {
    return <div className="empty-mini">Инсайтов пока нет — добавьте больше транзакций</div>;
  }
  return (
    <div className="insights-list">
      {insights.map((it) => (
        <div key={it.id} className={`insight-card insight-${it.tone}`}>
          <div className="insight-icon">{toneIcon(it.tone)}</div>
          <div className="insight-body">
            <div className="insight-title">{it.title}</div>
            <div className="insight-text">{it.body}</div>
            {it.actionLabel && it.actionDeepLink ? (
              <button
                type="button"
                className="link-btn"
                style={{ marginLeft: 0, marginTop: 4, padding: 0 }}
                onClick={() => onAction?.(it.actionDeepLink ?? '')}
              >
                {it.actionLabel}
              </button>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}
